// Vuex Settings module mutations types
export const FILL_BUTTON_ICONS_LIST = 'MUTATION_NAME';
export const FILL_WIDGET_ICONS_LIST = 'FILL_WIDGET_ICONS_LIST';
export const FILL_BEHAVIOR_TYPES_LIST = 'FILL_BEHAVIOR_TYPES_LIST';
export const FILL_PACKAGE_DEFINITIONS = 'FILL_PACKAGE_DEFINITIONS';
export const FILL_FAQ_LIST = 'FILL_FAQ_LIST';
export const ADD_SEARCH_KEYWORD_IN_FAQ_LIST = 'ADD_SEARCH_KEYWORD_IN_FAQ_LIST';
export const REMOVE_SEARCH_KEYWORD_IN_FAQ_LIST = 'REMOVE_SEARCH_KEYWORD_IN_FAQ_LIST';
export const CLEAR_SEARCH_KEYWORDS_IN_FAQ_LIST = 'CLEAR_SEARCH_KEYWORDS_IN_FAQ_LIST';
